// Sprint 1 Trust Restoration nav:
//   Logo (Home) | Home | About | Start Here | The Path (dropdown) |
//   Proof (dropdown) | Ecosystem | Journal | Clarity Reset Session
//
// The oversized "Clarity Snapshot" button is removed from the
// title bar. The Snapshot remains the primary first-touch CTA on
// the homepage Hero, Explainer, Pathway, Showcase, Voices, and
// Final CTA sections. Dropdowns let us preserve depth without
// crowding the desktop nav.
//
// "Home" added as an explicit label in addition to the logo's
// implicit Home link, so visitors arriving from a deep page
// (/voices, /journal/...) see a one-tap path back to the homepage
// without needing to recognize the logo as clickable.
export const NAV_LINKS = [
  { id: "home", label: "Home", route: "/" },
  { id: "about", label: "About", route: "/about" },
  { id: "start-here", label: "Start Here", route: "/start-here" },
  {
    id: "the-path",
    label: "The Path",
    variant: "dropdown",
    items: [
      { id: "book", label: "Authentic Momentum", route: "/book" },
      { id: "blueprint", label: "Personal Action Plan", route: "/start-here#step-blueprint" },
      { id: "deeper-paths", label: "Deeper Paths", route: "/start-here#step-sprint" },
    ],
  },
  {
    id: "proof",
    label: "Proof",
    variant: "dropdown",
    items: [
      { id: "gallery", label: "Gallery", route: "/proof" },
      { id: "voices", label: "Voices & Reflections", route: "/voices" },
    ],
  },
  { id: "ecosystem", label: "Ecosystem", route: "/ecosystem" },
  { id: "journal", label: "Journal", route: "/journal" },
  {
    id: "orientation-reset",
    label: "Clarity Reset Session",
    route: "/orientation-reset/schedule",
  },
];

export const LOGO_SRC = "/assets/logo.png";

export const updateHash = (id) => {
  // Avoid duplicate history entries when re-clicking the same section.
  if (window.location.hash !== `#${id}`) {
    window.history.pushState(null, "", `#${id}`);
  }
};

/**
 * Route-aware section navigation.
 * - On "/": pushes the hash (creates a usable history entry) and smooth-scrolls.
 * - On any other route (/about, /ecosystem, /checkout/*): full-navigates to
 *   /#id so the deep link is visible to the user and the homepage hash bootstrap
 *   in App.js scrolls to the right section after mount.
 */
export const navigateToSection = (id) => {
  if (window.location.pathname !== "/") {
    window.location.href = `/#${id}`;
    return;
  }
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    updateHash(id);
  }
};

// Backwards-compatible alias (was used in older Navigation).
export const scrollToSection = navigateToSection;
